import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { getDeployedMerchantOverrides } from 'Services';
import { useTranslation } from 'react-i18next';
import { RQ_MERCHANT_OVERRIDES } from 'Utils';
import { transformMerchantOverrides } from '../helper';

function useDeployedMerchantOverrides(enable: boolean, version?: number) {
    const { t } = useTranslation();
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery([RQ_MERCHANT_OVERRIDES], () => getDeployedMerchantOverrides(templateRepositoryId!, version), {
        enabled: enable,
        select: transformMerchantOverrides(t)
    });
}

export default useDeployedMerchantOverrides;
